import { render, staticRenderFns } from "./OpcaoBusca.vue?vue&type=template&id=b51ebd00&scoped=true"
import script from "./OpcaoBusca.vue?vue&type=script&lang=js"
export * from "./OpcaoBusca.vue?vue&type=script&lang=js"
import style0 from "./OpcaoBusca.vue?vue&type=style&index=0&id=b51ebd00&prod&lang=scss"
import style1 from "./OpcaoBusca.vue?vue&type=style&index=1&id=b51ebd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51ebd00",
  null
  
)

export default component.exports